'use strict';

/*jshint unused: false*/
var slateDirective = /*@ngInject*/ function ($state, NoteService) {
  return {
    restrict: 'E',
    replace: true,
    require: '?^^slateModal',
    scope: {},
    bindToController: {
      job: '='
    },
    controllerAs: 'slate',
    controller: 'SlateController as ctrl',
    templateUrl: 'templates/partials/slate/slate.tpl.html',
    link: function (scope, elem, attrs, ctrl, x) {
      scope.$watch(
        function () {
          return scope.slate.job;
        },
        scope.slate.init,
        true
      );
    }
  };
};

module.exports = slateDirective;
